import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74569b20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "started-style" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle-button" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('HomeGetStarted.title')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('HomeGetStarted.subtitle')), 1),
          _createVNode(_component_router_link, { to: {name:"SelectTemplate"} }, {
            default: _withCtx(() => [
              _createVNode($setup["AppButtonOutlined"], { class: "button-style" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('HomeGetStarted.button')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_7
  ]))
}